<template>
<el-date-picker
    v-model="date"
    :placeholder="'请选择'"
    :unlink-panels="true"
    size="small"
    :type="(type==='week'||type==='date')?'daterange':'monthrange'"
    range-separator="至"
    :picker-options="getOption"
    value-format="timestamp"
    clearable
    @change='(val)=>{setValue(val)}'
    @blur='handleBlur'
>
</el-date-picker>
</template>
<script>

export default {
    name:"WeekDatePicker",
    props:{
        type:{
            type:String,
            default:"date"
        },
        value:{
          type:Array,
          default:[]
        }
        
        
    },
    watch:{
        type:{
            handler(newVal,oldVal){
                if(newVal!=oldVal){
                    this.date = []
                }
               
            },
            deep:true,
            

        },
        value:{
          handler(newVal){
            this.date = _.cloneDeep(newVal)
          },
          deep:true,
          immediate:true
        }
    },
    created(){
        
    },
    computed:{   
      getOption(){
        let res = {}
        if(this.type==='week'){
          
          res = {
            onPick: (time) => {
              if (!time.minDate){
                this.timeStart = null
              }
              if (time.minDate && !time.maxDate) {
                this.timeOptionRange = time.minDate;
                this.timeStart = time.minDate
              }
              if (time.maxDate) {
                this.timeOptionRange = null;
              }
            },
            firstDayOfWeek:1,
            disabledDate: (time) => {
              let timeOptionRange = this.timeOptionRange;
              if(!this.timeStart){
                return time.getDay()!=1
              }else{
                if(timeOptionRange){
                  return time.getDay()!=0||time.getTime()<timeOptionRange.getTime()
                }
              }
              
            },
          }
        }else{
          res= {
            onPick: (time) => {
            },
            firstDayOfWeek:1,
            disabledDate: (time) => {
              
              
            },
          }
        }
        return res
      }
    },
    data(){
        return {
            date:[],
        }
    },
    methods:{
      handleBlur(){
        this.timeStart = null
      },
        setValue(val){
            this.$emit('input',val)
            this.$emit('change',val)
            this.timeStart = null
        }
    }
    
}
</script>